import styled from 'styled-components'

import { hexWithAlpha } from 'utils'
import radioActive from 'images/radioActive.svg'
import radio from 'images/radio.svg'

export const RadioGroup = styled.form`
	display: flex;
	flex-direction: column;
	margin: 0;
	align-self: stretch;
	max-height: 50vh;
	overflow-y: auto;
`

interface ColorProps {
	background: string,
	selectionBackground: string,
}

export const RadioRow = styled.div<ColorProps>`
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 15px 0 15px 15px;
	
	background: ${({ background }) => background};
	
	&.active {
		border-radius: 16px;
		background: ${({ selectionBackground }) => selectionBackground};
	};
	border-top: 1px solid ${({ selectionBackground }) => selectionBackground};
	:last-child {
		border-bottom: 1px solid ${({ selectionBackground }) => selectionBackground};
	}
	&.active + :not(.active) {
		border-top: none;
	}
	:first-child {
		border-top: none;
	}
	
	transition: background 100ms ease;	
`

export const Radio = styled.div`
	position: relative;
`

interface Checkable {
	active: boolean
}

export const RadioIcon = styled.img.attrs(({ active }: Checkable) => ({
	src: active
		? radioActive
		: radio,
}))`
	height: 23px;
	width: 23px;
	border-radius: 50%;
	position: relative;
	${(props: Checkable) => ''};
	transition: 200ms ease;

`

interface RadioActiveCircleProps {
	innerCircleColor: string
}

export const RadioActiveCircle = styled.div<RadioActiveCircleProps>`
	position: absolute;
	width: 11.5px;
	height: 11.5px;
	border-radius: 50%;
	background: ${({ innerCircleColor }) => innerCircleColor};
	top: 0;
	left: 0;
	transform: translate(50%, 50%);
`

interface RightFadeProps {
	active: boolean
	fadeEndPercent: number,
	fadeWidth: string,
	background: string,
	selectedBackground: string
}

const genFadeBackground = (props: RightFadeProps) => {
	const color = props.active
		? props.selectedBackground
		: props.background

	return 'linear-gradient(90deg, '
		+ hexWithAlpha(color, 0) + ' 0%, '
		+ hexWithAlpha(color, 1) + ' ' + props.fadeEndPercent + '%)'
}

export const RightFade = styled.div<RightFadeProps>`
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 10;
	width: ${({ fadeWidth }) => fadeWidth};
	background: ${genFadeBackground};
`
